import React from 'react';
import { NavLink } from 'react-router-dom';
import Send from '../Helper/Send';
import { Badge } from 'rsuite';


export default class Header extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            new_notfy: null,
            is_live: null
        }
    }

    componentDidMount() {

        Send('page/notfy/new', null, true).then((res) => {
            this.setState({ 
                new_notfy: res.data.new_notfy,
                is_live: res.data.is_live,
            });
        }).catch((err) => { });

    }





    render() {




        return (


            <div className="phone-tab-bar ">


                <nav className="mobile_b_bar">
                    <ul>
                        <li key='nav_1'>

                            <NavLink aria-expanded="false" exact="true" to="/">
                                    <span className="icon-Home"></span>
                            </NavLink>
                        </li>
                    </ul>

                    <ul>
                        <li key='nav_2'>

                            <NavLink aria-expanded="false" exact="true" to="/orders">
                            {this.state.is_live == 1 ?

                                  <Badge content="لایو" className='px-1'><span className="icon-damble-2-2"></span></Badge>

                                :<span className="icon-damble-2-2"></span>
                                }

                            </NavLink>
                        </li>
                    </ul>

                    <ul>
                        <li key='nav_3'>
                            <NavLink aria-expanded="false" exact="true" to="/cart">
                                <span className="icon-Basket"></span>
                            </NavLink>
                        </li>
                    </ul>


                    <ul>
                        <li key='nav_4'>
                            <NavLink aria-expanded="false" exact="true" to="/blog">


                            <span className="icon-plan-1"></span>



                            </NavLink>
                        </li>
                    </ul>

                    <ul>
                        <li key='nav_5'>
                            <NavLink aria-expanded="false" exact="true" to="/profile">
                                <span className="icon-Profile"></span>
                            </NavLink>
                        </li>
                    </ul>






                </nav>



            </div>


        )
    }
}

